import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-license-banner',
  templateUrl: './license-banner.component.html',
  styleUrls: ['./license-banner.component.scss'],
})
export class LicenseBannerComponent implements OnInit {
  public isActiveBannerLicense = environment.activeLicense;

  constructor() {}

  ngOnInit(): void {}
}
